// extracted by mini-css-extract-plugin
export default {"headerContainer":"headerContainer__tnwoOJhZ","newWindowIcon":"newWindowIcon__f_RyX82i"};